import checkIfSelectionIsInsideQuestion from '../LogicsManager/LogicsTypes/TriggersFn/utils/checkIfSelectionIsInsideQuestion';

export default (editor) => {
  if (!checkIfSelectionIsInsideQuestion()) {
    editor.insertContent('<p contenteditable="false" class="page-break"/>');
  }
};
